<button *ngIf="language$ | async as language" class="button button--lined button--menu button--menu--start language-selector"
        [routerLink]="[]"
        [queryParams]="{'lang': language === 'de' || language === 'dels' ? 'en' : 'de'}"
        queryParamsHandling="merge"
        title="{{title(language)}}"
        >
  <mat-icon [svgIcon]="language === 'de' || language === 'dels' ? 'lang_de' : 'lang_en'">
  </mat-icon>
</button>
